import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CoffeeIcon } from 'lucide-react';
export function Bonus() {
  return <section className="py-16 px-6" data-id="element-13">
      <div className="container mx-auto max-w-4xl" data-id="element-14">
        <motion.div className="bg-gradient-to-br from-mint/40 to-sage/20 rounded-3xl p-8 md:p-12 border border-sage/30 relative overflow-hidden shadow-lg shadow-sage/5" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          {/* Ribbon effect */}
          <div className="absolute top-0 right-0 bg-sage text-cream text-xs font-bold px-12 py-2 transform translate-x-[30%] translate-y-[50%] rotate-45 shadow-md" data-id="element-16">
            GRATIS HOY
          </div>

          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 relative z-10" data-id="element-17">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-sm shrink-0" data-id="element-18">
              <GiftIcon className="w-10 h-10 text-sage" data-id="element-19" />
            </div>

            <div className="text-center md:text-left" data-id="element-20">
              <div className="text-sage font-bold tracking-widest text-sm mb-2 uppercase" data-id="element-21">
                Bonus Exclusivo
              </div>
              <h3 className="text-3xl font-serif mb-4 flex items-center justify-center md:justify-start gap-3" data-id="element-22">
                <CoffeeIcon className="text-forest/50" data-id="element-23" />
                Guía: 3 Infusiones de Rescate Nocturno
              </h3>
              <p className="text-charcoal/80 leading-relaxed" data-id="element-24">
                Recetas exactas de infusiones botánicas para tomar antes de
                dormir. Diseñadas específicamente para relajar el tracto
                digestivo y amanecer con el vientre plano.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}